import { useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRefinementList } from "react-instantsearch-core";
import { filterRecentlyModified } from "@actions/catalog-actions";

export function useRecentlyModifiedFilters() {
  return useSelector((state) => state.catalog.filtersRecentlyModified);
}

export function useFilterRecentlyModified() {
  const dispatch = useDispatch();

  return (filter) => dispatch(filterRecentlyModified(filter));
}

export function useSizes() {
  const user = useSelector((state) => state.user.currentUser);
  const { items: inStockItems } = useRefinementList({
    attribute: "in_stock",
  });
  const { items: inStockForC1Items } = useRefinementList({
    attribute: "in_stock_for_c1",
  });
  const { items: allSizesItems, refine: refineAllSizes } = useRefinementList({
    attribute: "sizes",
  });
  const { items: availableSizesItems, refine: refineAvailableSizes } = useRefinementList({
    attribute: "available_sizes",
  });
  const { items: availableSizesForC1Items, refine: refineAvailableSizesForC1 } = useRefinementList({
    attribute: "available_sizes_for_c1",
  });

  const { sizeItems, isFilterAvailableChecked } = useMemo(() => {
    const isNotInStockApplied = inStockItems.find((item) => item.label === "false")?.isRefined;
    const isNotInStockForC1Applied = inStockForC1Items.find(
      (item) => item.label === "false",
    )?.isRefined;
    const isFilterAvailableCheckedRes = user?.c1_dedicated
      ? !isNotInStockForC1Applied
      : !isNotInStockApplied;

    let sizeItemsRes;

    if (isFilterAvailableCheckedRes) {
      if (user?.c1_dedicated) {
        sizeItemsRes = availableSizesForC1Items;
      } else {
        sizeItemsRes = availableSizesItems;
      }
    } else {
      sizeItemsRes = allSizesItems;
    }

    return {
      sizeItems: sizeItemsRes,
      isFilterAvailableChecked: isFilterAvailableCheckedRes,
    };
  }, [
    inStockItems,
    inStockForC1Items,
    user?.c1_dedicated,
    availableSizesForC1Items,
    availableSizesItems,
    allSizesItems,
  ]);

  const refineSize = useCallback(
    (optionValue) => {
      if (isFilterAvailableChecked) {
        if (user?.c1_dedicated) {
          return refineAvailableSizesForC1(optionValue);
        }

        return refineAvailableSizes(optionValue);
      }

      return refineAllSizes(optionValue);
    },
    [
      isFilterAvailableChecked,
      refineAllSizes,
      refineAvailableSizes,
      refineAvailableSizesForC1,
      user?.c1_dedicated,
    ],
  );

  return { sizeItems, refineSize, isFilterAvailableChecked };
}
